<template>
    <div class="sw-modal confirm-dialog">
        <div v-click-outside="cancelAction" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4>Confirm action</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <div class="row">
                    <div class="col-12">
                        <span v-html="message"></span>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div class="row">
                        <div class="col text-center">
                            <button v-if="!hideCancelButton" class="btn btn-normal" v-on:click.stop="cancelAction()">{{cancelButtonText}}</button>
                            <button v-if="showSecondaryAction" class="btn btn-secondary" v-on:click.stop="continueSecondaryAction()">{{continueSecondaryButtonText}}</button>
                            <button class="btn btn-primary" v-on:click.stop="continuePrimaryAction()">{{continuePrimaryButtonText}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ConfirmDialog',
        components: {
        },
        props: {
            message: String,
            callbackPrimaryName: String,
            callbackPrimaryReference: String,
            continuePrimaryText: String,
            callbackSecondaryName: String,
            callbackSecondaryReference: String,
            continueSecondaryText: String,
            cancelText: String,
            hideCancelButton: Boolean
        },
        data: function() {
            return {
                canCancel: false,
            }
        },
        computed: {
            showSecondaryAction: function() {
                if (this.callbackSecondaryName && this.callbackSecondaryReference && this.continueSecondaryText) {
                    return true;
                }
                return false;
            },
            continuePrimaryButtonText: function() {
                if (this.continuePrimaryText) {
                    return this.continuePrimaryText;
                } else {
                    return "Continue"
                }
            },
            continueSecondaryButtonText: function() {
                if (this.continueSecondaryText) {
                    return this.continueSecondaryText;
                } else {
                    return "Continue"
                }
            },
            cancelButtonText: function() {
                if (this.cancelText) {
                    return this.cancelText;
                } else {
                    return "Cancel"
                }
            }
        },
        methods: {
            cancelAction: function() {
                if (this.canCancel) {
                    console.log("cancel");
                    this.$root.$emit(this.callbackPrimaryName);
                }
            },
            continuePrimaryAction: function() {
                console.log("continue primary");
                this.$root.$emit(this.callbackPrimaryName, this.callbackPrimaryReference);
            },
            continueSecondaryAction: function() {
                console.log("continue secondary");
                this.$root.$emit(this.callbackSecondaryName, this.callbackSecondaryReference);
            },
        },
        mounted() {
            setTimeout(() => {
                this.canCancel = true;
            }, 500);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/components/modal.scss";
    @import "../styles/components/confirm_dialog.scss";
</style>